import { ElementRef, Injectable, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';
import { environment } from "src/environments/environment";
import { AngularFirestore, DocumentData } from '@angular/fire/compat/firestore';
import { UploadFileService } from './upload-file.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  private deletedItemSubject = new BehaviorSubject<boolean>(false);

  deletedItem$ = this.deletedItemSubject.asObservable();

  private addItemSubject = new BehaviorSubject<boolean>(false);

  addItem$ = this.addItemSubject.asObservable();
  constructor(private http: HttpClient, private firestore: AngularFirestore, private uploadFile: UploadFileService) {

  }
  deleteItem(): void {
    this.deletedItemSubject.next(true);
  }

  addItem(): void {
    this.addItemSubject.next(true);
  }

  allS3Bucket(data: any): Observable<any> {
    return this.http.post<any>(`${environment.firebaseCloudfunction.allS3Bucket}`, data);
  }

  createS3Bucket(data: FormData): Observable<any> {
    return this.http.post<any>(`${environment.firebaseCloudfunction.createS3Bucket}`, data, {
      reportProgress: true,
      observe: 'events'
    });
  }

  createS3Object(data: any): Observable<any> {
    return this.http.post<any>(`${environment.firebaseCloudfunction.createS3object}`, data);
  }

  // , {
  //   reportProgress: true,
  //   observe: 'events'
  // } 

  DownloadFile(data: any): Observable<any> {
    return this.http.post(environment.firebaseCloudfunction.downloadFileFromURL, data);
  }

  getonlyBuckets() {
    return this.http.get<any>(`${environment.firebaseCloudfunction.onlyS3Bucket}`);
  }

  data: any;

  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  async getBlobData(url: string, action: boolean): Promise<any> {
    try {
      // Extract the filename from the URL
      const name = await this.getFileNameFromURL(url, action);
      console.log(name, 'file');
      const filename = await this.uploadFile.replaceSpacesWithUnderscores(name)
      console.log(filename, 'file after remove extra things');

      // Process the URL to get the video duration
      this.data = await this.ProcessFunction(url);
      console.log(this.data, 'data from function')
      const timeDuration = this.data.time;
      const size = this.data.size;

      // Return an object containing the URL, filename, and video duration
      return { data: url, filename, timeDuration, size };
    } catch (error) {
      console.error('Error fetching Blob data:', error);
      throw error;
    }
  }


  async ProcessFunction(url: any) {
    try {
      const observable = await this.getVideoDuration(url);
      const data = await observable.toPromise();
      console.log('Video duration:', data);
      return data;
    } catch (error) {
      console.error('Error fetching video duration:', error);
      throw error;
    }
  }

  async getVideoDuration(url: any): Promise<Observable<number>> {
    return this.http.post<any>(`${environment.firebaseCloudfunction.videoDuration}`, { url: url });

    // const videoElement = document.createElement('video');
    // videoElement.src = URL.createObjectURL(blobData);

    // const metadataLoaded = new Promise<void>((resolve, reject) => {
    //   videoElement.onloadedmetadata = () => resolve();
    //   videoElement.onerror = (error) => reject(error);
    // });

    // try {
    //   await metadataLoaded;
    //   return videoElement.duration;
    // } catch (error) {
    //   console.error('Error loading video metadata:', error);
    //   throw error;
    // } finally {
    //   URL.revokeObjectURL(videoElement.src);
    // }
  }


  // async  getVideoDuration(blobData: Blob): Promise<number> {
  //   const videoElement = document.createElement('video');
  //   videoElement.src = URL.createObjectURL(blobData);

  //   // Create a Promise to resolve when metadata is loaded
  //   const metadataLoaded = new Promise<void>((resolve, reject) => {
  //     videoElement.onloadedmetadata = () => resolve();
  //     videoElement.onerror = (error) => reject(error);
  //   });

  //   // Wait for metadata to be loaded
  //   try {
  //     await metadataLoaded;
  //     return videoElement.duration;
  //   } catch (error) {
  //     console.error('Error loading video metadata:', error);
  //     throw error; // Handle error accordingly
  //   } finally {
  //     // Clean up
  //     URL.revokeObjectURL(videoElement.src);
  //   }
  // }

  getDuration(data: any): Observable<any> {
    return this.http.post(environment.firebaseCloudfunction.getBlobdata, data);
  }


  getGCPData(mediaLink: string): Observable<any> {
    return this.http.get(mediaLink, { responseType: 'blob' });
  }

  //   async  getGCPData(url:string) {
  //     try {
  //       // Extract the filename from the URL
  //       const filename = this.getFileNameFromURL(url);

  //       // Fetch the blob data
  //       const blobData: any = await this.http.get(url).toPromise();
  //       // Create a video element to extract the duration
  //       const videoElement = document.createElement('video');
  //       console.log(videoElement)
  //       videoElement.src = URL.createObjectURL(blobData);

  //       // Create a Promise to resolve when metadata is loaded
  //       const metadataLoaded = new Promise<void>((resolve, reject) => {
  //         videoElement.onloadedmetadata = () => resolve();
  //         videoElement.onerror = (error) => reject(error);
  //       });

  //       // Wait for metadata to be loaded
  //       await metadataLoaded;

  //       // Extract the video duration
  //       const timeDuration = videoElement.duration;

  //       // Return an object containing blob data, time duration, and filename
  //       return { data: blobData, timeDuration: timeDuration, filename: filename };
  //     } catch (error) {
  //       console.error('Error fetching Blob data:', error);
  //       throw error;
  //     }
  // }




  // Function to extract filename from URL
  //   getFileNameFromURL(url1: string,act:boolean): string {
  //  var d;
  //     if(act==true){
  //        d = url1.split('@')[0];
  //     }
  //     else{
  //       d=url1;
  //     }


  //    const urlParts = d.split('/');
  //    const url= urlParts[urlParts.length - 1];

  //     const videoExtensions = ['.mp4', '.avi', '.mkv', '.mov']; // Add more extensions if needed

  //     // Find the index of the first occurrence of any video extension
  //     const extensionIndex = videoExtensions.reduce((index, extension) => {
  //         // Find the index of the current extension
  //         const currentIndex = url.indexOf(extension);

  //         // If the current extension is found and it's before the previous found extension, update the index
  //         if (currentIndex !== -1 && (index === -1 || currentIndex < index)) {
  //             return currentIndex;
  //         }

  //         // Otherwise, keep the previous index
  //         return index;
  //     }, -1);

  //     if (extensionIndex !== -1) {
  //         // Remove everything after the extension
  //         return url.substring(0, extensionIndex + 4);
  //     }

  //     // If no video extension is found, return the original URL
  //     return url;


  //   }

  getFileNameFromURL(url: string, act: boolean): string {
    const cleanedUrl = act ? url.split('@')[0] : url;
    const urlParts = cleanedUrl.split('/');
    const fileNameWithExtension = urlParts[urlParts.length - 1];

    const videoExtensions = ['.mp4', '.avi', '.mkv', '.mov']; // Add more extensions if needed

    // Find the index of the first occurrence of any video extension
    const extensionIndex = videoExtensions.reduce((index, extension) => {
      // Find the index of the current extension
      const currentIndex = fileNameWithExtension.indexOf(extension);

      // If the current extension is found and it's before the previous found extension, update the index
      return (currentIndex !== -1 && (index === -1 || currentIndex < index)) ? currentIndex : index;
    }, -1);

    // If a video extension is found, return the filename with the extension, else return the original URL
    const filename = extensionIndex !== -1 ? fileNameWithExtension.substring(0, extensionIndex + 4) : fileNameWithExtension;
    console.log(filename, 'filename')
    // Replace spaces with underscores in the filename
    const filenameWithoutSpaces = filename.replace(/ /g, '_');
    console.log(filenameWithoutSpaces, 'filenameWithoutSpaces')
    return filenameWithoutSpaces;
  }


  getNameFromPath(path: any): string {
    console.log("🔧 [FILENAME-EXTRACT] Starting getNameFromPath");
    console.log("🔧 [FILENAME-EXTRACT] Input path:", path);

    // Assuming path is a string
    const fileNameWithExtension = path.split('/').pop(); // Get the last part of the path
    console.log("🔧 [FILENAME-EXTRACT] FileNameWithExtension:", fileNameWithExtension);

    const videoExtensions = ['mp4', 'avi', 'mov', 'm4v', 'mpeg', 'webm', 'ogg', 'mpeg2', 'mxf', 'ts'] // Add more extensions if needed

    // Extract extension and filename separately
    let extension = '';
    let filenameWithoutExtension = fileNameWithExtension;

    videoExtensions.forEach(ext => {
      if (fileNameWithExtension.toLowerCase().endsWith('.' + ext.toLowerCase())) {
        console.log("🔧 [FILENAME-EXTRACT] Found extension:", ext);
        extension = ext.toLowerCase();
        filenameWithoutExtension = fileNameWithExtension.slice(0, -(ext.length + 1)); // +1 for the dot
      }
    });
    console.log("🔧 [FILENAME-EXTRACT] FilenameWithoutExtension:", filenameWithoutExtension);
    console.log("🔧 [FILENAME-EXTRACT] Extension:", extension);

    // Replace spaces with underscores in the filename
    const filenameWithoutSpaces = filenameWithoutExtension.replace(/ /g, '_');
    console.log("🔧 [FILENAME-EXTRACT] FilenameWithoutSpaces:", filenameWithoutSpaces);

    // Replace special characters with underscores
    const filenameWithoutSpecialChars = filenameWithoutSpaces.replace(/[^\w\s]/gi, '_');
    console.log("🔧 [FILENAME-EXTRACT] ProcessedFilename:", filenameWithoutSpecialChars);

    // Return filename WITH extension for Lambda compatibility
    const finalFilename = extension ? `${filenameWithoutSpecialChars}.${extension}` : filenameWithoutSpecialChars;
    console.log("🔧 [FILENAME-EXTRACT] Final filename WITH extension:", finalFilename);

    return finalFilename;
  }




  deletePaymentMethod(data: any) {
    return this.http.post<any>(`${environment.firebaseCloudfunction.deletePaymentMethond}`, data);
  }







  oneTimeIntegrationPayment(userData: any): Observable<any> {
    //@ts-ignore
    return this.http.post<any>(`${environment.firebaseCloudfunction.createOneTimePayment}`, userData);
  }


  createCustomer(userData: any): Observable<any> {
    //@ts-ignore
    console.log("user statsu", userData)
    return this.http.post<any>(`${environment.firebaseCloudfunction.createCustomer}`, userData);
  }

  retrievePaymentMethods(userData: any): Observable<any> {
    //@ts-ignore
    console.log("user statsu", userData)
    return this.http.post<any>(`${environment.firebaseCloudfunction.retrievePaymentMethods}`, userData);
  }

  s3BucketCreate(userData: any): Observable<any> {
    //@ts-ignore
    console.log("user statsu", userData)
    return this.http.post<any>(`${environment.firebaseCloudfunction.createS3Bucket}`, userData);
  }



  getDocumentsByEmail(email: string) {
    return this.firestore.collection('SUBSCRIPTION_USERDATA', (ref) =>
      ref.where('customerDetails.email', '==', email)
    ).valueChanges();
  }
  //   createUser(userData: { email: string; password: string }): Promise<string> {
  //     return this.auth.createUserWithEmailAndPassword(userData.email, userData.password)
  //       .then((userCredential) => userCredential.user?.uid || '')
  //       .catch((error) => {
  //         console.error('Error creating user in Firebase:', error);
  //         throw error;
  //       });
  //   }

  //   checkUserExists(email: string): Observable<boolean> {
  //     // Convert the Promise into an Observable
  //     return from(this.auth.fetchSignInMethodsForEmail(email))
  //       .pipe(
  //         map((signInMethods) => signInMethods.length > 0),
  //         catchError((error) => {
  //           console.error('Error checking user existence:', error);
  //           return of(false); // Assuming user does not exist on error
  //         })
  //       );
  //   }

  //   createUserProfile(uid: string, email: string, displayName: string): Promise<void> {
  //     const userDocRef = this.firestore.collection('users').doc(uid);

  //     return userDocRef.set({
  //       uid: uid,
  //       email: email,
  //       displayName: displayName,
  //     });
  //   }

  //   convertFirestoreTimestamp(timestamp: Timestamp): Date | null {
  //     if (timestamp) {
  //       return timestamp.toDate();
  //     } else {
  //       return null; // or handle the case where timestamp is undefined
  //     }
  //   }




  //   allMembersData(adminUId: string, uid: string, email: string, displayName: string,userProfileImage:any): Promise<void> {

  //     const userDocRef = this.firestore.collection('ADMIN_MEMBERS').doc(adminUId).collection('members').doc(uid);

  //     return userDocRef.set({
  //       uid: uid,
  //       email: email,
  //       displayName: displayName,
  //       timestamp: new Date(),
  //       isUserActive: true,
  //       userProfileImage:userProfileImage
  //     });
  //   }


  //   getAllMembers(adminUserId: string): Observable<MemberData[]> {
  //     const collectionRef = this.firestore.collection(`ADMIN_MEMBERS/${adminUserId}/members`);

  //     // Get a snapshot of the collection and convert Timestamp to Date
  //     return collectionRef.get().pipe(
  //       map((querySnapshot) => {
  //         const data: MemberData[] = [];
  //         querySnapshot.forEach((doc) => {
  //           const docData = doc.data() as MemberData;
  //           const timestamp = docData.timestamp;
  //           const convertedTimeStamp = this.convertFirestoreTimestamp(timestamp);
  //           docData.timestamp = convertedTimeStamp
  //           data.push({ ...docData, id: doc.id });
  //         });
  //         return data;
  //       })
  //     );
  //   }


  //   updateMemberIsUserActive(adminUid: string, email: string, isUserActive: boolean): Promise<void> {
  //     const adminMembersCollectionRef = this.firestore.collection(`ADMIN_MEMBERS/${adminUid}/members`);

  //     // First, find the member document with the provided email
  //     return adminMembersCollectionRef
  //       .ref.where('email', '==', email)
  //       .get()
  //       .then((querySnapshot) => {
  //         if (querySnapshot.empty) {
  //           // Member with the provided email not found
  //           throw new Error(`Member with email ${email} not found.`);
  //         }

  //         // Update the 'isUserActive' field for the first matching member
  //         const memberDocRef = querySnapshot.docs[0].ref;
  //         return memberDocRef.update({ isUserActive: isUserActive });
  //       })
  //       .catch((error) => {
  //         console.error('Error updating member isUserActive:', error);
  //         throw error;
  //       });
  //   }



  //   // UpdateUserData function in FirebaseService
  // updateUserData(uid: string, isChecked: any,integration:any): Observable<any> {
  //   const userDocRef = this.firestore.collection('integration').doc(uid).collection(integration).doc('integrationState');

  //   return new Observable((observer) => {
  //     userDocRef.set(
  //       { integrationModule: isChecked },
  //       { merge: true }
  //     )
  //     .then(() => {
  //       // console.log('User data updated successfully');
  //       observer.next(true);
  //       observer.complete();
  //     })
  //     .catch((error) => {
  //       console.error('Error updating user data:', error);
  //       observer.error(error);
  //     });
  //   });
  // }

  // getIntegrationModule(uid: string,integration:any): Observable<any> {
  //   const userDocRef = this.firestore.collection('integration').doc(uid).collection(integration).doc('integrationState');

  //   return new Observable((observer) => {
  //     userDocRef.get()
  //       .subscribe((docSnapshot) => {
  //         if (docSnapshot.exists) {
  //           const integrationModule = docSnapshot.get('integrationModule');
  //           observer.next(integrationModule);
  //           observer.complete();
  //         } else {
  //           console.log('Document does not exist');
  //           observer.next(null);
  //           observer.complete();
  //         }
  //       }, (error) => {
  //         console.error('Error fetching user data:', error);
  //         observer.error(error);
  //       });
  //   });
  // }


  // async setMobileService(uid: string,mobileServiceValue:boolean) {
  //   const integrationDocRef = this.firestore.collection('integration').doc(uid);
  //   try {
  //     await integrationDocRef.set(
  //       { mobileService: mobileServiceValue },
  //       { merge: true }
  //     );
  //     console.log('Mobile service set successfully');
  //   } catch (error) {
  //     console.error('Error setting mobile service: ', error);
  //     throw error;
  //   }
  // }



  async setMobileService(uid: string, mobileServiceValue: boolean) {
    const integrationDocRef = this.firestore.collection('integration').doc(uid);
    try {
      await integrationDocRef.set(
        { mobileService: mobileServiceValue },
        { merge: true }
      );
      console.log('Mobile service set successfully');
    } catch (error) {
      console.error('Error setting mobile service: ', error);
      throw error;
    }
  }


  getMobileService(uid: string, field: string) {
    const integrationDocRef = this.firestore.collection('integration').doc(uid);

    return integrationDocRef.get().pipe(
      ((doc: any) => {
        if (doc.exists) {
          const data = doc.data() as DocumentData;
          const fieldValue = data[field];
          return fieldValue;
        } else {
          console.log('Document does not exist');
          return null;
        }
      })
    );
  }

}
